import {
  PLAYER_TIME_SLIDER_MAX_CHANGE,
  PLAYER_TIME_SLIDER_VAL_CHANGE,
} from 'containers/Player/actions/optionButtons/constants';

const initialState = {
  value: 0,
  max: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_TIME_SLIDER_VAL_CHANGE:
      return { ...state, value: action.payload };
    case PLAYER_TIME_SLIDER_MAX_CHANGE:
      return { ...state, max: action.payload };
    default:
      return state;
  }
};
